module.exports = __webpack_public_path__ + "img/pic_07@2x.574621d4.png";